import {useSelector} from 'react-redux'
import {RootState} from 'store'

export const useIsConnected = () =>
  useSelector((state: RootState) => state.editor.isConnected)
